
import N12 from '../N1/N1 (1).webp'
import N13 from '../N1/N1 (2).webp'
import N14 from '../N1/N1 (3).webp'
import N15 from '../N1/N1 (4).webp'
import N16 from '../N1/N1 (5).webp'
import N17 from '../N1/N1 (6).webp'
import N18 from '../N1/N1 (7).webp'
import N19 from '../N1/N1 (8).webp'
import N110 from '../N1/N1 (9).webp'
import N111 from '../N1/N1 (10).webp'



const N1images =[
    N12,N13,N14,N15,N16,N17,N18,N19,N110,N111
]

export default N1images;